import { render, staticRenderFns } from "./bind_preferential.vue?vue&type=template&id=55bfb71d"
import script from "./bind_preferential.vue?vue&type=script&lang=js"
export * from "./bind_preferential.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports